<template>
  <div id="app">
    <div class="app-mfe">
      <header class="app-mfe__header">
        <h1>Data Discovery <span class="app-mfe__header__env-label" v-if="this.environmentName !== 'production'">({{ this.environmentName }})</span></h1>
        <p>Find data providers and their documentation, as well as curate business context for the consumers of your data.</p>
      </header>
      <div class="app-mfe__container">
        <ul class="app-mfe__navigation">
          <li class="app-mfe__navigation__item"
              :class="{ selected: $route.path === '/home' || $route.path === '/' }"
          >
            <a href="#/home" @click="resetSearch()">Home</a>
          </li>
          <li class="app-mfe__navigation__item"
              :class="{ selected: $route.path === '/myBookmarks' }"
          >
            <a href="#/myBookmarks">My Bookmarks</a>
          </li>
          <li class="app-mfe__navigation__item"
              :class="{ selected: $route.path === '/myDatasets' || $route.path === '/myTables' }"
          >
            <a href="#/myDatasets">My Datasets</a>
          </li>
        </ul>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'AppMfe',
  inject: ['authManager', 'platformClient'],
  components: {},
  data() {
    return {
      environmentName: process.env.VUE_APP_ENVIRONMENT
    };
  },
  computed: {
    ...mapState({
      userDetails: state => state.customizr.userDetails
    })
  },
  async created() {
    try {
      await this.getUserDetails({ platformClient: this.platformClient });
      await this.updateUserVisitCount();
      await this.putUserDetails({ platformClient: this.platformClient, userDetailsObject: this.userDetails });
      if (this.userDetails.visitCount < 3 && this.$route.path === '/') {
        this.$refs.tourRef.callOnCreate(this.steps[0].target);
      }
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    ...mapActions({
      getUserDetails: 'customizr/getUserDetails',
      putUserDetails: 'customizr/putUserDetails',
      updateUserVisitCount: 'customizr/updateUserVisitCount'
    }),
    resetSearch() {
      this.$store.commit('search/searchInput', {
        searchText: null,
        filters: {}
      });
      this.$store.commit('search/selectedTreeItem', null);
      this.$store.commit('search/searchResult', null);
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' });
      }
    }
  }
};
</script>
<style scoped>

.app-mfe__header {
  background-color: #F8F9FA;
}

.app-mfe__header h1 {
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  margin: 9px 0px;
}

.app-mfe__header__env-label {
  font-size: 16px;
  font-weight: 400;
  color: #007798;
}

.app-mfe__header p {
  font-size: 16px;
  line-height: 24px;
}

.app-mfe {
    background: #F8F9FA;
    padding: 24px;
}

.app-mfe__container {
    background: #FFFFFF;
    padding: 12px 24px 24px 24px;
}

.app-mfe__navigation {
    list-style-type: none;
    margin: 0;
    display: flex;
    gap: 20px;
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 24px;
    height: 48px;
}

.app-mfe__navigation__item {
    font-size: 16px;
}

.app-mfe__navigation__item a {
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;
    text-decoration: none;
    color: #15191D;
    font-weight: 600;
    padding-left: 4px;
    padding-right: 4px;
}

.app-mfe__navigation__item.selected {
    border-bottom: 2px solid #007798;
}

.app-mfe__navigation__item.selected a {
    color: #007798;
}

.app-mfe__navigation__item:hover {
    border-bottom: 2px solid #007798;
}
</style>
